module.exports = "button{\r\n    margin-left: 20px;\r\n}"